import { render } from "./index.vue?vue&type=template&id=02e0f5dc"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=02e0f5dc&lang=scss"

import exportComponent from "C:\\Users\\igor.kondratiev\\Documents\\работа\\проекты\\faq\\faq\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__